import { get, post, put, remove } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';
import { translate } from '../Services/translation';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';
export const CART_ORDER_ROWS_UPDATE = 'CART_ORDER_ROWS_UPDATE';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error
    }
});

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart
});

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
}

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible
    }
});

export const add = ({ articleNumber, quantity = 1, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {

    return (dispatch) => {
        if (!quantity || isNaN(quantity)) {
            return false;
        }

        return post('/api/cart/add', { articleNumber, quantity: parseInt(quantity) })
            .then(response => response.json())
            .then(cart => {
                if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                    gtag('event', cart.event, cart.dataLayer);
                }
                dispatch(receive(cart));
                nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const addMany = ({ articles, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {

    return (dispatch) => {
        return post('/api/cart/addmany', articles)
            .then(response => response.json())
            .then(cart => {
                if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                    gtag('event', cart.event, cart.dataLayer);
                }
                if (document.getElementById('checkout')) {
                    location.reload();
                } else {
                    dispatch(receive(cart));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                }
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const clear = ({ nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {

    return (dispatch) => {
        return post('/api/cart/clear')
            .then(response => response.json())
            .then(cart => {
                dispatch(receive(cart));
                nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const reorder = ({ orderId, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {

    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then(response => response.json())
                .then(cart => {
                    if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                        gtag('event', cart.event, cart.dataLayer);
                    }
                    dispatch(receive(cart));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))));
        }
    }

    return false;
}

export const update = (rowSystemId, quantity) => (dispatch) => {

    return put(`/api/cart/update`, { rowSystemId, quantity })
        .then(response => response.json())
        .then(cart => {
            if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                gtag('event', cart.event, cart.dataLayer);
            }
            dispatch(receive(cart))
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const doSplitOrder = () => (dispatch) => {

    return put(`/api/cart/splitOrder`)
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const onDeliveryDateDelete = (systemId, title) => (dispatch, getState) => {

    const confirmed = confirm(translate('common.checkout.delivery.button.deletedate') + ': ' + title);

    if (!confirmed) {
        return false;
    }

    return put(`/api/cart/deliveryDateDelete`, { deliverySystemId: systemId })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

//export const onDeliveryDateDelete = (deliverySystemId, dateName) => (dispatch) => {

//    console.log(deliverySystemId);
//    console.log(dateName);

//    if (deliverySystemId) {
//        const confirmed = confirm(translate('common.checkout.delivery.button.deletedate') + ': ' + dateName);

//        if (!confirmed) {
//            return false;
//        }
//        return put(`/api/cart/deliveryDateDelete`, { deliverySystemId: deliverySystemId })
//                .then(response => response.json())
//                .then(cart => dispatch(receive(cart)))
//                .catch(ex => dispatch(catchError(ex, error => loadError(error))))
//            ;
//    }

//    return false;
//}

export const updateComment = (rowSystemId, comment) => (dispatch) => {

    return put(`/api/cart/updateOrderRowComment`, { rowSystemId, comment })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const updateCustomerPrice = (rowSystemId, newCustomerPrice) => (dispatch) => {

    return put(`/api/cart/updateOrderRowCustomerPrice`, { rowSystemId, newCustomerPrice })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const updateOrderIsNetPrice = (rowSystemId, isNetPrice) => (dispatch) => {

    return put(`/api/cart/updateOrderRowIsNetPrice`, { rowSystemId, isNetPrice })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const orderRowDeliveryDateChange = (rowSystemId, rowIndex, dateIndex) => (dispatch, getState) => {

    let dateObject = {};
    const orderRows = [...getState().cart.orderRows];

    if (orderRows) {
        dateObject = { ...orderRows[rowIndex].availableDatesToDeliverList[dateIndex] };
    }

    if (dateObject) {
        if (orderRows) {
            orderRows[rowIndex].selectedDeliveryDate = dateObject;
            dispatch({
                type: CART_ORDER_ROWS_UPDATE,
                payload: {
                    orderRows
                }
            });
        }
        dateObject.rowSystemId = rowSystemId;

        return put(`/api/cart/orderRowDeliveryDateChange`, { deliveryDateInfoValue: dateObject.deliveryDateInfoValue, rowSystemId: dateObject.rowSystemId, deliveryDate: dateObject.deliveryDate })
            .then(response => response.json())
            .then(cart => dispatch(receive(cart)))
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }

    return false;
}

export const updateOrderDiscount = (discount) => (dispatch) => {

    return put(`/api/cart/updateOrderDiscount`, { discount })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}